export const ReactForward = Symbol.for('react.forward_ref')
export const ReactMemo = Symbol.for('react.memo')
